// extracted by mini-css-extract-plugin
export default {"container":"ZeroToFive--container--bc4d35","title":"ZeroToFive--title--3d8f22","description":"ZeroToFive--description--0fdae6","actions":"ZeroToFive--actions--d81271"};